import {Component, OnInit} from '@angular/core';
import {CardsContent} from "../news/news.component";
import {TranslateService} from "../../../services/translate.service";

@Component({
    selector: 'app-convention',
    templateUrl: './convention.component.html',
    styleUrls: ['./convention.component.css']
})
export class ConventionComponent implements OnInit {

    allConventionPointsEng: CardsContent [] = [
        {
            title: 'What is it? PSY Convention. For whom and why?',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'In general psy convention upgrades every year. In the last moth of the year final version approved. Conventions different with year option. If we are talking about psy convention without year.',
                'It means. Upgrading the last version of convention. All top world specialist in areas connected to human psyche are working on it. A lot of problems in every area connected to human psyche. In medicine, life, relations, family building, business and others.',
                'Most of them are result of low level of individual/group/global psychoanalysis and psychology in general. One of the biggest problem, is epidemy of PPM. Almost impossible to grow in modern world without serious psyche injuries and diagnosis as a result.',
                'Main golas of psy convention:',
                '• help individuals non professionals to upgrade skills connected to psychology',
                '• help individuals professionals to upgrade skills and stop doing mistakes',
                '• help upgrade level of psychoanalysis in communities globally',
                '• help to protect human rights in treatment using different methods: globally, locally',
                '• fighting with epidemy of ppm and reinforce/help others locally/globally',
                '• and others improving quality of helthcare helping to grow good professionals and protect human rights in treatment'
            ],
            links: []
        },
        {
            title: 'PSY Convention 2018. Point 1.',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Separation of powers. Very often the diagnosis is subjective and erroneous. which is already a crime and prevents thinking about the wrong diagnosis, as well as fear for personal reputation.',
                'These factors, and often the same level of psychoanalysis and their own bunch of symptoms, make it almost impossible to correct the diagnosis on the voluntary initiative of the employee who made a mistake. it is necessary to deprive the power of medical workers to violate the constitutional rights of a person and send them for mandatory treatment of a non-existent or erroneous disease.',
                'Violation of constitutional rights can be only by a court decision when it comes to crimes committed because of the symptoms. for example, attempts to bring to suicide or incitement of hostility, if the motive of these crimes were symptoms of mental illness.',
                'Summary: deprive the illegal power of medical workers, which is actually used to commit a multitude of crimes from the Criminal Code of the Russian Federation.',
                'To make the procedure of state hospitalization completely transparent and without fail to check for violation of 293, 126, 110 articles of the criminal code of the Russian Federation.'
            ],
            links: []
        },
        {
            title: 'PSY Convention 2018. Point 2.',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Start from psychoanalysis - always different types of personality are characterized by different processes in the psyche.',
                'The same circumstances and/or influence can cause completely different and/or opposite mental processes in different types of personality. not taking this into account is a very gross and popular mistake.',
                'Most often, a conscious, predictable effect on the psyche without this stage is impossible.',
                'Summary: always begin with the analysis of not only the patient or client but also the most accurate psychoanalysis of the persons with whom he/she contacts.',
                'Very often, a properly formulated condition is 90% of the solution.'
            ],
            links: []
        },
        {
            title: 'PSY Convention 2018. Point 3.',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Clear Cause-Effect Relationship. A lot of subjective theories and points of view today are called psychology. Most of them are based on the painful, not systematic experience that the author of a particular theory has experienced.',
                'All these theories are not science, because they have no causal relationships. This is misleading. the science of the human psyche, psychology has clear and transparent causal relationships. only those methods can be used in which the causal effect is fully traced. otherwise, that\'s all.',
                'But not the science of the human psyche - psychology.',
                'It could be philosophy, mysticism, fraud, etc. Summary: In any statement, a causal connection to the basic processes in the psyche should be traced.'
            ],
            links: []
        }
    ];

    allConventionPointsRus: CardsContent [] = [
        {
            title: 'Что это? PSY-Конвенция. Для кого и зачем?',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'В общем и целом PSY-Конвенция обновляется каждый год. В последнем месяце года окончательный вариант утверждается. После этого к конвенции прикрепляется год принятия и это становится версией. Если мы говорим о PSY-Конвенции без года.',
                'Это значит. Идет обновление последней версии конвенции. Над этим работают все ведущие мировые специалисты в областях, связанных с психикой человека. Много серьезные проблемы в разных сферах, связаны с психикой человека.',
                ' В медицине, жизни, отношениях, построении семьи, бизнесе и других. Большинство из них являются результатом низкого уровня индивидуального/группового/глобального психоанализа и психологии в целом.',
                'Одной из самых больших проблем является эпидемия КПМ. Почти невозможно вырасти в современном мире без серьезных травм психики и, как следствие, диагнозов.',
                'Основные цели PSY-Конвенции:',
                '• помочь людям, не являющимся профессионалами, совершенствовать навыки, связанные с психологией',
                '• помочь отдельным профессионалам улучшить навыки и перестать делать ошибки',
                '• помочь повысить уровень психоанализа в сообществах по всему миру',
                '• помочь защитить права человека при лечении, используя различные методы: глобально, локально',
                '• бороться с эпидемией кпм и укреплять/помогать другим на местном/глобальном уровне',
                '• и другие, улучшая качество здравоохранения, помогая вырастить хороших специалистов и защитить права человека при лечении'
            ],
            links: []
        },
        {
            title: 'PSY-Конвенция 2018. Пункт 1.',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Разделение полномочий очень часто диагностика субъективна и ошибочна. что уже является преступлением и препятствует обдумыванию неверного диагноза, так же как и боязнь за личную репутацию. эти факторы, а также, часто, нулевой унровень психоанализа и собственный букет симптомов психического расстройства, делают практически невозможным исправление диагноза на добровольной инициативе сотрудника, допустившего ошибку.',
                'Необходимо лишить власти медицинских работников нарушать конституционные права человека и отправлять на обязательное лечение от несуществующей или ошибочной болезни.',
                'Нарушение конституционных прав может быть только по решению суда, когда идет речь о преступлениях совершенных из-за симпомов. Например, попытки доведения до суицида или возбуждение вражды, если мотивом этих преступлений были симптомы душевной болезни.',
                'Резюме: лишить незаконной власти медицинских работников, которая фактически используется для совершения множества преступлений из УК РФ. Сделать процедуру госптализации полностью прозрачной и в обязательном порядке проверять на нарушение 293, 126, 110 статей уголовного кодекса РФ.'
            ],
            links: []
        },
        {
            title: 'PSY-Конвенция 2018. Пункт 2.',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Начинать с психоанализа - всегда\n' +
                'для разных типов личности характерны разные процессы в психике. Одинаковые обстоятельства и/или воздествие могут вызвать совершенно разные и/или противоположные процессы психики в разных типах личности. не учитывать данное обстоятельство - очень грубая и популярная ошибка.',
                'Чаще всего, сознательный, прогнозируемы эффект на психику без этого этапа невозможен. Резюме: всегда начинать с писхоанализа не только пациента или клиента, но и максимально точного психоанализа лиц, с которыми он/она контактирует. Очень часто правильно сформулированное условие - это 90+ процентов решения.'
            ],
            links: []
        },
        {
            title: 'PSY-Конвенция 2018. Пункт 3.',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Ясная причинно-следственная связь. Очень много субьективных теорий и точек зрения сегодня называют словом психология. большинство из них базируется на болезненном, не систематизированном опыте, который пережил автор той или иной теории.',
                'Все эти теории не являются наукой, т.к. в них нет причинно-следственных связей. Это вводит людей в заблуждение. Наука о человеческой психике, психология имеет четкие и прозрачные причинно следственные связи. Использовать можно только те методики, в которых причинно следственная связь прослеживается полностью.',
                'Иначе это все, что угодно. Но не наука о человеческой психики - психология. Это может быть философия, мистика, мошенничество и т.п.',
                'Резюме: в любом утверждении должна прследиваться причинно слдественная связь к базовым процессам в психике.'
            ],
            links: []
        }
    ];

    constructor(private translate: TranslateService) {
    }

    ngOnInit() {
    }

    goLink(link: string) {
        setTimeout(() => {
            window.open(link, '_blank');
        }, 300);
    }

}
